// Module
var code = "<div if=\"buttons.length\" class=\"gc-custom-buttons\"> <template for=\"button in buttons\"> {{ button }} </template> </div>";
// Exports
export default code;